var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token_exists)?_c('div',[_c('paya-report-table')],1):_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('label.token_does_not_exist'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }